module.exports = __webpack_public_path__ + "img/soft-bg-1.ae9b6d99.png";